import { useQuery } from "@tanstack/react-query";
import { getBudgets } from "../api/planner";
import { useTranslation } from "react-i18next";

export const useBudgets = () => {
    const { i18n } = useTranslation();

    return useQuery({
        queryKey: ["budgets", i18n.resolvedLanguage],
        queryFn: () => getBudgets(i18n.resolvedLanguage || "en"),
        staleTime: Infinity,
    });
};
